import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Command {
  execute(): void;
  getDescription(): string;
}

export interface ActionCommand extends Command {
  getKey(): string;
}

@Injectable({
  providedIn: 'root'
})
export class ActionCommandService {
  private commands = new Map<string, ActionCommand>();
  private currentContext = new BehaviorSubject<string>('');

  constructor() {
    this.setupGlobalKeyListeners();
  }

  private setupGlobalKeyListeners(): void {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      const key = this.getKeyFromEvent(event);
      if (key) {
        // Prevenir comportamento padrão do navegador (ex: F1 abre help)
        event.preventDefault();
        event.stopPropagation();
        this.executeCommand(key);
      }
    });
  }

  private getKeyFromEvent(event: KeyboardEvent): string | null {
    // Mapear teclas de função
    if (event.key.startsWith('F') && event.key.length > 1) {
      return event.key;
    }
    
    // Mapear outras teclas especiais
    if (event.key === 'Escape') {
      return 'ESC';
    }
    
    return null;
  }

  registerCommand(command: ActionCommand): void {
    this.commands.set(command.getKey(), command);
  }

  unregisterCommand(key: string): void {
    this.commands.delete(key);
  }

  executeCommand(key: string): void {
    const command = this.commands.get(key);
    if (command) {
      command.execute();
    }
  }

  getAvailableCommands(): ActionCommand[] {
    return Array.from(this.commands.values());
  }

  setContext(context: string): void {
    this.currentContext.next(context);
  }

  getCurrentContext(): Observable<string> {
    return this.currentContext.asObservable();
  }

  clearCommands(): void {
    this.commands.clear();
  }
}
